import { useState } from 'react';
import SiteLayout from '@/components/feature/SiteLayout';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestSection from '@/pages/home/components/LatestSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqPreviewSection from '@/pages/home/components/FaqPreviewSection';
import CtaSection from '@/pages/home/components/CtaSection';
import { useSeo } from '@/hooks/useSeo';
import { site } from '@/utils/site';

export default function Home() {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  useSeo({
    title: '黑料看点 | 精彩片段 高能名场面合集 爆点精华一网打尽',
    description: site.description,
    keywords: site.keywords,
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.name,
        url: origin,
        description: site.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${origin}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.name,
        description: site.description,
        email: site.email,
      },
    ],
  });

  const handleSearch = (value: string) => {
    setQuery(value);
    setActiveCategory('all');
    requestAnimationFrame(() => {
      document.getElementById('latest')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <SiteLayout transparentHeader>
      <HeroSection onSearch={handleSearch} />
      <FeaturedSection />
      <CategoryGrid />
      <LatestSection
        query={query}
        onQueryChange={setQuery}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />
      <TestimonialSection />
      <FaqPreviewSection />
      <CtaSection />
    </SiteLayout>
  );
}